<template>
  <span>
    <a v-if="href.slice(href.length - 4) == '.pdf'"
      target="_blank"
      @click="forceClickToggleBar()"
      class="nav-link nav-mobile mx-xl-3 test 1"
      :class="{'active-custom-ff': isTheUrl}"
      :href="href"
      >{{ title }}</a
    >
    <Link v-else
      @click="forceClickToggleBar()"
      class="nav-link nav-mobile mx-xl-3 test"
      :class="{'active-custom-ff': isTheUrl}"
      :href="href"
      >{{ title }}</Link
    >
  </span>
</template>

<script>
export default {
  props: {
    title: String,
    isTheUrl: Boolean,
    href: String,
  },
}
</script>

<style>

</style>
